import type React from 'react';

import { NoSSRLoggedInSuspense } from '@xing-com/crate-utils-no-ssr';

import { Container } from './container';

export const Component: React.FC = () => (
  <NoSSRLoggedInSuspense>
    <Container />
  </NoSSRLoggedInSuspense>
);
